<template>
	<div class="d-flex justify-content-end">
		<div v-if="isFetching">
			<div class="is-loading large"></div>
		</div>
		<div class="ml-a" v-if="!isFetching">
			<span v-tooltip="$t('Total User')">
				<md-icon class="icon-total-user mr-1">groups</md-icon>
				<span class="text-primary">{{userStatistics && userStatistics.total_user ? userStatistics.total_user : '0'}}</span>
			</span>
			<span class="vl"></span>
			<span v-tooltip="$t('Total Subscription')">
				<md-icon class="icon-collaborator mr-1">storage</md-icon>
				<span class="text-primary">{{userStatistics && userStatistics.total_subscription ? userStatistics.total_subscription : '0'}}</span>
			</span>
			<span class="vl"></span>
			<span v-tooltip="$t('Verified User')">
				<md-icon class="icon-total-user mr-1">check</md-icon>
				<span class="text-primary">{{userStatistics && userStatistics.total_user_verified ? userStatistics.total_user_verified : '0'}}</span>
			</span>
			<span class="vl"></span>
			<span v-tooltip="$t('Unverified User')">
				<md-icon class="icon-total-user mr-1">close</md-icon>
				<span class="text-primary">{{userStatistics && userStatistics.total_user_unverified ? userStatistics.total_user_unverified : '0'}}</span>
			</span>
			<span class="vl"></span>
			<span v-tooltip="$t('Super Admin')">
				<md-icon class="icon-super-admin mr-1">person</md-icon>
				<span class="text-primary">{{userStatistics && userStatistics.total_super_admin ? userStatistics.total_super_admin : '0'}}</span>
			</span>
			<span class="vl"></span>
			<span v-tooltip="$t('Client')">
				<md-icon class="icon-client mr-1">people</md-icon>
				<span class="text-primary">{{userStatistics && userStatistics.total_client ? userStatistics.total_client : '0'}}</span>
			</span>
			<span class="vl"></span>
			<span v-tooltip="$t('Collaborator')">
				<md-icon class="icon-collaborator mr-1">group_add</md-icon>
				<span class="text-primary">{{userStatistics && userStatistics.total_collaborator ? userStatistics.total_collaborator : '0'}}</span>
			</span>
		</div>
	</div>
</template>

<script>
import usersApi from '@/api/user';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'UserStatistics',
	data() {
		return {
			userStatistics: [],
			isFetching: false,
		};
	},
	props: {
	},
	methods: {
		fetch() {
			this.isFetching = true;
			const callback = (response) => {
				const items = response.data;
				this.userStatistics = items;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isFetching = false;
			};
			usersApi.getStatistics(callback, errorCallback);
		},
	},
	created() {
		this.fetch();
	},
	computed: {
	},
	watch: {
	},
};
</script>
